import { render } from "./ScrollToTop.vue?vue&type=template&id=fe29f0c8"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/margaretriver.com/margaretriver.com/river/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__